import Vue from "vue";

export const store = Vue.observable({
  uploadHeader: [],
  uploadColumn: [],
  uploadOrders: [],
  uploadFileName: "",
  selectedInputNo: [],
  selectedFile: null,
  denpyou_no: "",

  captureCount: "",
  errCount: "",
  warnCount: "",
  orderCount: "",

  order_screen_ptn_di: ""
});

export const getters = Vue.observable({});
